import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { MessagingProvider } from './contexts/MessagingContext';
import { ActivityProvider } from './contexts/ActivityContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import UpdateBanner from './components/UpdateBanner';
import './setupAxe'; // Enable accessibility testing in development

// Silence console.log/debug in production builds to keep DevTools clean
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <UpdateBanner />
    <AuthProvider>
      <MessagingProvider>
        <ActivityProvider>
          <App />
        </ActivityProvider>
      </MessagingProvider>
    </AuthProvider>
  </React.StrictMode>
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('ClinicCore is now available offline!');
  },
  onUpdate: () => {
    console.log('New version available! Please refresh to update.');
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
